import { render, staticRenderFns } from "./SharedMediaFolderFilter.vue?vue&type=template&id=547edfa0&"
import script from "./SharedMediaFolderFilter.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports